module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_naracamicie-b2e3c37b5f0123df59a3752fcce3647f.svg";